{
  "app": {
    "name": "Atlas OMS"
  },
  "action": {
    "save": "บันทึก",
    "save_draft": "บันทึกฉบับร่าง",
    "cancel": "ยกเลิก",
    "delete": "ลบ",
    "duplicate": "ทำสำเนา",
    "export": "ส่งออก",
    "search": "ค้นหา",
    "clear": "ล้าง",
    "back": "",
    "continue": "",
    "create": "สร้าง",
    "edit": "",
    "sign_in": "",
    "sign_out": "ออกจากระบบ",
    "get_started": "เริ่มต้นใช้งาน"
  },
  "empty": {
    "no_results": "ไม่พบผลลัพธ์ที่ตรงกัน",
    "no_data": "",
    "clear_filters": ""
  },
  "pagination": {
    "rows_per_page": "แถวต่อหน้า",
    "page_of": "หน้า {{current}} จาก {{total}}",
    "sorted_by_newest": "เรียงจากใหม่สุด",
    "prev": "ก่อนหน้า",
    "next": "ถัดไป",
    "showing": "แสดง {{from}}–{{to}} จาก {{total}}"
  },
  "user_menu": {
    "profile": "โปรไฟล์",
    "language": "ภาษา",
    "sign_out": "ออกจากระบบ"
  },
  "loading": "",
  "saving": "",
  "state": {
    "loading": "กำลังโหลด",
    "error": "เกิดข้อผิดพลาด"
  },
  "placeholder": {
    "empty": "—"
  },
  "errors": {
    "unexpected": "เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง",
    "network": "เครือข่ายขัดข้อง ตรวจสอบการเชื่อมต่อของคุณ",
    "forbidden": "คุณไม่มีสิทธิ์ดำเนินการนี้",
    "request_failed": "คำขอล้มเหลว ({{status}})"
  },
  "actions": {
    "dismiss": "ปิด"
  },
  "density": {
    "label": "ความหนาแน่นแถว",
    "compact": "กระชับ",
    "default": "ปกติ",
    "comfortable": "สบายตา"
  },
  "filters": {
    "active": "ตัวกรองที่ใช้งาน",
    "clear_all": "ล้างทั้งหมด"
  },
  "language": { "label": "ภาษา", "en": "EN", "th": "TH" }
}
